import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useEntityTotals } from '@printdeal/checkout-frontend';
import { Money } from '../../../../Money';
import { SanitizedOrder } from '../../../../../types/order/Order';
import { vatCorrectDecimal } from '../../../../../helpers/vatHelper';

interface OrderTaxPortionsProps {
  order: SanitizedOrder;
}

const OrderTaxPortions = ({
  order,
}: OrderTaxPortionsProps) => {
  // @ts-expect-error type mismatch
  const { entityTotal } = useEntityTotals({ entity: order });

  return (
    <>
      {entityTotal?.totalPrice && entityTotal.totalPrice.taxPortions.map(({ amount, rate }) =>
        (rate === 0 || (rate > 0 && amount.centAmount > 0)) && (
          <div className="pd-flex pd-gap-x-4" key={`${order.id}-${rate}`}>
            <div className="pd-flex pd-grow pd-flex-col pd-gap-x-4 lg:pd-flex-row">
              <div className="pd-w-full pd-font-bold lg:pd-w-48">
                <FormattedMessage
                  id="order.detail.payment.vat"
                  defaultMessage="VAT amount"
                />
              </div>
              <div className="pd-grow">
                {`${vatCorrectDecimal(rate)} %`}
              </div>
            </div>
            <div>
              <Money value={amount.centAmount} />
            </div>
          </div>
        ))}
    </>
  );
};

export default OrderTaxPortions;
